var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Autosuggest',{attrs:{"value":_vm.value,"label":_vm.config.PROFILE_ADDRESS_STATE,"disabled":_vm.disabled,"options":_vm.filteredStates},on:{"input":_vm.onInput,"select":_vm.onSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }